import * as React from "react";

import { Link } from "react-router";
import { Navbar } from "react-bootstrap";
import { connect } from "shared/src/stores/storeConnect";
import { withReactAdapter } from "shared/src/module-federation/withReactAdapter";
import MobileNavigationActions from "../../../actions/MobileNavigationActions";
import { MobileMenu } from "./MobileMenu";
import { MetroLogo } from "../MetroLogo";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import SearchInput from "./../SearchInput";
import { isMetroX } from "../../../searchdiscover/toggles";
import { CartStore } from "../../../stores/CartStore";
import { MENU_STATE } from "./MenuState";
import { isFsdShop } from "shared/src/utils/ShopFlavor";
import MobileNavigationHistoryStore from "../../../stores/MobileNavigationHistoryStore";
import { MetroXStoreSelector } from "../globalheader/store/MetroXStoreSelector";
import * as GlobalHeaderUtil from "../../../utils/GlobalHeaderUtil";

type Props = {
    isCheckout: boolean;
    onQuery: (query: string, suggestion: boolean, facets: string | undefined | null) => void;
    placeholderId: string;
    partOfGlobalHeader: boolean;
    enableSuggestions: boolean;
    isMenuVisible: boolean;
    menuState?: string | null | undefined;
    shoppingCartItemCount: number;
    reduced: boolean;
    country: string;
    shoppingCartVisible: boolean;
    children?: React.ReactNode;
    isUsingExternalNavigationComponent: boolean;
    onToggleMenu: (isMenuVisible: boolean) => void;
};

export class MobileHeader extends React.Component<Props> {
    setNavigationOpen = () => {
        MobileNavigationActions.ChangeState(MENU_STATE.START);
    };

    goToMyStore = () => {
        MobileNavigationActions.ChangeState(MENU_STATE.MYSTORE, true);
    };

    goToMyAddresses = () => {
        MobileNavigationActions.ChangeState(MENU_STATE.MYADDRESSES, true);
    };

    setNavigationClose = () => {
        MobileNavigationActions.CloseMobileMenu();
    };

    componentDidUpdate(prevProps: Props) {
        if (this.props.isUsingExternalNavigationComponent && !!prevProps.isMenuVisible !== !!this.props.isMenuVisible) {
            this.props.onToggleMenu(this.props.isMenuVisible);
        }
    }

    handleSearchQuery(query: string) {
        if (this.props.onQuery !== undefined && this.props.onQuery !== null) {
            this.props.onQuery(query, false, null);
        }
        this.setNavigationClose();
    }

    renderMenuClosedOpenIcon(navigationOpen: boolean) {
        if (this.props.reduced) {
            return (
                <td>
                    <div className="brandbar-toggle-menu" />
                </td>
            );
        } else {
            return (
                <td>
                    <div className="brandbar-toggle-menu">
                        {navigationOpen ? (
                            <a onClick={this.setNavigationClose}>
                                <i className="icon-big-mobile-close icon-2x" />
                            </a>
                        ) : (
                            <a onClick={this.setNavigationOpen}>
                                <i className="icon-big-mobile-menu icon-2x" />
                            </a>
                        )}
                    </div>
                </td>
            );
        }
    }

    renderLogoOrSearchInput(navigationOpen: boolean) {
        return (
            <td className="text-center">
                {navigationOpen || isMetroX() ? (
                    <div className="brandbar-search">
                        <SearchInput
                            onQuery={this.handleSearchQuery.bind(this)}
                            placeholderId={this.props.placeholderId}
                            partOfGlobalHeader={this.props.partOfGlobalHeader}
                            enableSuggestions={this.props.enableSuggestions}
                            isMobile
                        />
                    </div>
                ) : (
                    <Link to="/">
                        <MetroLogo country={this.props.country} />
                    </Link>
                )}
            </td>
        );
    }

    renderCart() {
        if (this.props.reduced) {
            return (
                <td className="text-right">
                    <div className="mini-shopping-cart" />
                </td>
            );
        } else if (this.props.shoppingCartVisible) {
            const alignment = isMetroX() ? "text-center" : "text-right";
            return (
                <td className={alignment}>
                    <div className="mini-shopping-cart">
                        <Link to="/cart" onClick={() => MobileNavigationActions.CloseMobileMenu()}>
                            <span className="icon-big-mobile-cart icon-2x">
                                <span className="badge">{this.props.shoppingCartItemCount}</span>
                            </span>
                        </Link>
                    </div>
                </td>
            );
        } else {
            return null;
        }
    }

    renderClassicStoreSelector() {
        const isFsd = isFsdShop();
        const iconClass = isFsd ? "icon-big-delivery-address" : "icon-big-location";
        const handler = isFsd ? this.goToMyAddresses : this.goToMyStore;
        return (
            <td>
                <div className="brandbar-store">
                    <a className="brandbar-store-toggle" onClick={handler}>
                        <i className={"icon-2x " + iconClass} />
                    </a>
                </div>
            </td>
        );
    }

    renderMetroXMobileStoreSelector() {
        return (
            <div className={"metrox-store-selector-container-mobile"}>
                <MetroXStoreSelector />
            </div>
        );
    }

    render() {
        const navigationOpen = !!this.props.isMenuVisible;
        const showMenu = this.props.isUsingExternalNavigationComponent
            ? navigationOpen && (this.props.menuState === "mystore" || this.props.menuState === "myaddresses")
            : navigationOpen;
        const shouldRenderMetroXStoreSelector = GlobalHeaderUtil.shouldShowMetroXStoreSelector();
        return (
            <div>
                <Navbar
                    default
                    fluid
                    staticTop
                    className={"header-brandbar header-brandbar-mobile" + (isMetroX() ? " metrox" : "")}>
                    <table className="table-simple">
                        <tbody>
                            <tr>
                                {this.renderMenuClosedOpenIcon(navigationOpen)}
                                {this.renderLogoOrSearchInput(navigationOpen)}
                                {isMetroX() && !shouldRenderMetroXStoreSelector && this.renderClassicStoreSelector()}
                                {this.renderCart()}
                            </tr>
                        </tbody>
                    </table>
                </Navbar>
                {shouldRenderMetroXStoreSelector && this.renderMetroXMobileStoreSelector()}

                <ReactCSSTransitionGroup
                    transitionName="animation-slideFromLeft"
                    transitionAppear={!showMenu && !this.props.isUsingExternalNavigationComponent}
                    transitionAppearTimeout={0}
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    {showMenu && <MobileMenu />}
                </ReactCSSTransitionGroup>
                <div className="mfcss_header_extra_content">{this.props.children || null}</div>
            </div>
        );
    }
}

export default withReactAdapter(
    connect(
        {
            stores: [
                [MobileNavigationHistoryStore, ["isMenuVisible", "menuState"]],
                [CartStore, (s: typeof CartStore) => ({ shoppingCartItemCount: s.getItemCount() })]
            ]
        },
        MobileHeader
    )
);
